export default {
  showSubmitBatchConfirmation: false,
  allowDifferentAmount: false,
  allowItemsWithZeroUnitPrice: false,
  showSupplierProvideServicesConfirmation: false,
  selectSupplierCountry: false
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/modals-settings.js